import { render, staticRenderFns } from "./PrTableSamplePeaks.vue?vue&type=template&id=0bd0d5dc&scoped=true&"
import script from "./PrTableSamplePeaks.vue?vue&type=script&lang=js&"
export * from "./PrTableSamplePeaks.vue?vue&type=script&lang=js&"
import style0 from "./PrTableSamplePeaks.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrTableSamplePeaks.vue?vue&type=style&index=1&id=0bd0d5dc&lang=scss&scoped=true&"
import style2 from "./PrTableSamplePeaks.vue?vue&type=style&index=2&id=0bd0d5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0d5dc",
  null
  
)

export default component.exports